import {
  CaretLeftIcon,
  IconButton,
  IconButtonLink,
  IconButtonLinkIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import type {
  ReactNode,
  MouseEventHandler,
} from "react"
import styles from "./PageHeader.module.scss"
import { UserName } from "src/components"
import { useFollowedUsers } from "src/contexts"
import type { RoutePath } from "src/types"

interface Props {
  hideUserName?: boolean;
  backRoutePath?: RoutePath;
  onBackClick?: MouseEventHandler<HTMLButtonElement>;
  children?: ReactNode;
}

export function OnboardingPageHeader(props: Props) {
  const {
    backRoutePath,
    onBackClick,
    hideUserName = false,
  } = props

  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  return (
    <div className={styles.container}>
      <IconButtonLink
        className={styles.backButton}
        stylePreset="withoutBackground"
        id="header-left-button"
        asChild
      >
        {onBackClick ? (
          <IconButton onClick={onBackClick}>
            <CaretLeftIcon className={styles.backButtonIcon} />
          </IconButton>
        ) : backRoutePath ? (
          <Link
            to={backRoutePath}
            params={currentFollow.is_self ? {} : { accountId: currentUserId }}
            search={{}}
          >
            <IconButtonLinkIcon>
              <CaretLeftIcon className={styles.backButtonIcon} />
            </IconButtonLinkIcon>
          </Link>
        ) : null}
      </IconButtonLink>
      <div className={styles.centerText}>
        <div
          className={styles.title}
          id="page-title"
        >
          {props.children}
        </div>
        {!hideUserName && (
          <div
            className={styles.userName}
            id="user-name-header"
          >
            <UserName user="follow" />
          </div>
        )}
      </div>
    </div>
  )
}
